import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  CircularProgress,
  Alert,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  FormControlLabel,
  Checkbox,
  IconButton,
  Stack,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import {
  addHealthCheckup,
  fetchSpecialtiesList,
  fetchDoctorsList,
  fetchHealthCheckupPackageList,
  fetchHealthCheckupMasterTest,
  fetchHealthCheckupTestInclusion,
} from "../../Adapters/ApiAdapter";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SeoTags from "../SeoTags/SeoTags";

/* ---------- model for every master group ---------- */
const makeGroup = (master) => ({
  test_master_id: master?.id ?? null,
  test_master_name: master?.test_name ?? "",
  test_inclusion_ids: [],
  test_inclusion_names: [],
  test_inclusions: master?.test_inclusions || [],
});

const AddHealthCheckup = () => {
  const [formData, setFormData] = useState({
    health_checkup_name: "",
    slug: "",
    doctor_id: "",
    speciality_id: "",
    // health_checkup_package_id: "",
    checkup_title: "",
    checkup_fees: "",
    email: "",
    phone: "",
    contact_person: "",
    checkup_image: "",
    banner_img: "",
    og_image: "",
    twitter_image: "",
    seo_title: "",
    meta_title: "",
    meta_description: "",
    meta_keywords: "",
    custom_scripts: "",
    og_title: "",
    og_description: "",
    og_type: "",
    og_url: "",
    og_locale: "",
    og_site_name: "",
    og_image_width: "",
    og_image_height: "",
    og_image_type: "",
    article_modified_time: "",
    canonical_link: "",
    twitter_card: "",
    twitter_title: "",
    twitter_description: "",
    twitter_site: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [specialities, setSpecialities] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [pac, setPackage] = useState([]);
  const [testMasters, setTestMasters] = useState([]);
  const [selectedTestMaster, setSelectedTestMaster] = useState([]);
  const [selectedTestMasters, setSelectedTestMasters] = useState([]);
  const [selectedInclusionIds, setSelectedInclusionIds] = useState([]);
  const [inclusionsForSelectedMaster, setInclusionForSelectedMaster] = useState([]);
  const [testMasterInclusions, setTestMasterInclusions] = useState([]);
  const [loadingSpecialities, setLoadingSpecialities] = useState(true);
  const [loadingPackage, setLoadingPackage] = useState(true);
  const [loadingDoctors, setLoadingDoctors] = useState(true);
  const [checkupImg, setCheckUpImg] = useState(null);
  const [packages, setPackages] = useState([]);

  const [groups, setGroups] = useState([]); // array of makeGroup objects
  const [multiIds, setMultiIds] = useState([]);
  const [newMasterName, setNewMasterName] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const [spec, docs, packs, masters] = await Promise.all([
          fetchSpecialtiesList(),
          fetchDoctorsList(),
          fetchHealthCheckupPackageList(),
          fetchHealthCheckupMasterTest(),
        ]);

        setSpecialities(spec?.specialities ?? []);
        setDoctors(docs?.data ?? []);
        setPackages(packs?.data ?? []);

        /* pull inclusions for each master */
        const mastersWithInc = await Promise.all(
          (masters?.data ?? []).map(async (m) => {
            const inc = await fetchHealthCheckupTestInclusion(m.id);
            return { ...m, test_inclusions: inc?.data ?? [] };
          })
        );
        setTestMasters(mastersWithInc);
      } catch (err) {
        toast.error("Failed loading dropdown data");
      }
    })();
  }, []);

  useEffect(() => {
    const testAPI = async () => {
      const response = await fetchHealthCheckupTestInclusion(1);
      console.log("Inclusion Response:", response);
    };
    testAPI();
  }, []);

  //fetch speicalities

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchSpecialtiesList();
        if (response && response.specialities) {
          setSpecialities(response.specialities);
        } else {
          toast.error("Failed to load specialities.");
        }
      } catch (error) {
        toast.error("Error fetching specialities.");
      } finally {
        setLoadingSpecialities(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fechDoctor = async () => {
      try {
        const response = await fetchDoctorsList();
        if (response && response.data) {
          setDoctors(response.data);
        } else {
          toast.error("Failed to load specialities");
        }
      } catch (error) {
        toast.error("Eror fetching Doctors");
      } finally {
        setLoadingDoctors(false);
      }
    };
    fechDoctor();
  }, []);

  useEffect(() => {
    const fetchHealthPackage = async () => {
      try {
        const response = await fetchHealthCheckupPackageList();
        if (response && response.data) {
          setPackage(response.data);
        } else {
          toast.error("Failed to load package");
        }
      } catch (error) {
        toast.error("Error Fetching Package");
      } finally {
        setLoadingPackage(false);
      }
    };
    fetchHealthPackage();
  }, []);

  useEffect(() => {
    const fetchAllTestMasterInclusions = async () => {
      try {
        const masterRes = await fetchHealthCheckupMasterTest();

        const mastersWithInclusions = await Promise.all(
          masterRes.data.map(async (master) => {
            const inclusionRes = await fetchHealthCheckupTestInclusion(
              master.id
            );
            return {
              ...master,
              test_inclusions: inclusionRes?.data || [],
            };
          })
        );

        setTestMasters(mastersWithInclusions); // ✅ finally set the full list
      } catch (err) {
        console.error("Error fetching test master inclusions:", err);
      }
    };

    fetchAllTestMasterInclusions();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      let updatedForm = { ...prev, [name]: value };

      if (name === "health_checkup_name") {
        updatedForm.slug = generateSlug(value);
      }

      return updatedForm;
    });
  };

  const handleFileChange = (e, key, setPrevieState) => {
    const file = e.target.files[0];
    if (file) {
      setPrevieState(file);
      setFormData((prev) => ({
        ...prev,
        [key]: file,
      }));
    }
  };
  const generateSlug = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/&/g, " ")
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-");
  };

  /* ---------- master selection (multi) ---------- */
  const handleSelectMasters = (e) => {
    const ids = e.target.value;
    setMultiIds(ids);
    setGroups((prev) =>
      ids.map((id) => prev.find((g) => g.test_master_id === id) || makeGroup(testMasters.find((m) => m.id === id)))
    );
  };

  /* toggle inclusion id */
  const toggleId = (gi, incId, checked) =>
    setGroups((p) =>
      p.map((g, i) =>
        i === gi
          ? {
            ...g,
            test_inclusion_ids: checked
              ? [...g.test_inclusion_ids, incId]
              : g.test_inclusion_ids.filter((x) => x !== incId),
          }
          : g
      )
    );

  /* add new inclusion name */
  const addName = (gi, txt) => {
    const val = txt.trim();
    if (!val) return;
    setGroups((p) =>
      p.map((g, i) =>
        i === gi
          ? { ...g, test_inclusion_names: [...g.test_inclusion_names, val] }
          : g
      )
    );
  };

  /* add brand-new master */
  const addNewMaster = () => {
    const nm = newMasterName.trim();
    if (!nm) return;
    setGroups((p) => [...p, makeGroup({ test_name: nm })]);
    setNewMasterName("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const data = new FormData();

    /* primitive + file fields */
    Object.entries(formData).forEach(([k, v]) => {
      if (v instanceof File) data.append(k, v);
      else data.append(k, v ?? "");
    });

    /* append test_master_inclusions[] array style */
    groups.forEach((g, gi) => {
      if (g.test_master_id !== null)
        data.append(`test_master_inclusions[${gi}][test_master_id]`, g.test_master_id);
      else data.append(`test_master_inclusions[${gi}][test_master_name]`, g.test_master_name);

      g.test_inclusion_ids.forEach((id, ii) =>
        data.append(`test_master_inclusions[${gi}][test_inclusion_ids][${ii}]`, id)
      );

      g.test_inclusion_names.forEach((nm, jj) =>
        data.append(`test_master_inclusions[${gi}][test_inclusion_names][${jj}]`, nm)
      );
    });

    // const stripHtml = (html) => html.replace(/<[^>]+>/g, "").trim();
    data.append("health_checkup_name", String(formData.health_checkup_name));
    data.append("slug", formData.slug);
    data.append("doctor_id", formData.doctor_id);
    data.append("speciality_id", formData.speciality_id);
    // data.append(
    //   "health_checkup_package_id",
    //   formData.health_checkup_package_id
    // );
    data.append("checkup_title", formData.checkup_title);
    data.append("checkup_fees", formData.checkup_fees);
    data.append("email", formData.email);
    data.append("phone", formData.phone);
    data.append("contact_person", formData.contact_person);
    data.append("twitter_image", formData.twitter_image);
    data.append("seo_title", formData.seo_title);
    data.append("meta_title", formData.meta_title);
    data.append("meta_description", formData.meta_description);
    data.append("meta_keywords", formData.meta_keywords);
    data.append("custom_scripts", formData.custom_scripts);
    data.append("og_title", formData.og_title);
    data.append("og_description", formData.og_description);
    data.append("og_type", formData.og_type);
    data.append("og_url", formData.og_url);
    data.append("og_locale", formData.og_locale);
    data.append("og_site_name", formData.og_site_name);
    data.append("og_image_width", formData.og_image_width);
    data.append("og_image_height", formData.og_image_height);
    data.append("og_image_type", formData.og_image_type);
    data.append("article_modified_time", formData.article_modified_time);
    data.append("canonical_link", formData.canonical_link);
    data.append("twitter_card", formData.twitter_card);
    data.append("twitter_title", formData.twitter_title);
    data.append("twitter_description", formData.twitter_description);
    data.append("twitter_site", formData.twitter_site);

    if (formData.og_image instanceof File) {
      data.append("og_image", formData.og_image);
    }
    if (formData.banner_img instanceof File) {
      data.append("banner_img", formData.banner_img);
    }
    if (formData.checkup_image instanceof File) {
      data.append("checkup_image", formData.checkup_image);
    }
    if (formData.twitter_image instanceof File) {
      data.append("twitter_image", formData.twitter_image);
    }

    // data.append("test_master_inclusions", JSON.stringify(testMasterInclusions));
    // testMasterInclusions.forEach((item, index) => {
    //   data.append(`test_master_inclusions[${index}][test_master_id]`, item.test_master_id);
    //   item.selected_ids.forEach((id, i) => {
    //     data.append(`test_master_inclusions[${index}][test_inclusion_ids][${i}]`, id);
    //   });
    // });

    // console.log("Sending inclusions:", JSON.stringify(testMasterInclusions));

    for (let pair of data.entries()) {
      console.log(pair[0] + ", " + pair[1]);
    }

    try {
      const response = await addHealthCheckup(data);
      console.log("HealthCheckup:", response);
      if (response && response.status === "true") {
        console.log("TOAST should fire here");
        toast.success("HealthCheckUp Added Successsfully!");
        setFormData({
          health_checkup_name: "",
          slug: "",
          doctor_id: "",
          speciality_id: "",
          // health_checkup_package_id: "",
          checkup_title: "",
          checkup_fees: "",
          email: "",
          phone: "",
          contact_person: "",
          checkup_image: "",
          banner_img: "",
          og_image: "",
          twitter_image: "",
          seo_title: "",
          meta_title: "",
          meta_description: "",
          meta_keywords: "",
          custom_scripts: "",
          og_title: "",
          og_description: "",
          og_type: "",
          og_url: "",
          og_locale: "",
          og_site_name: "",
          og_image_width: "",
          og_image_height: "",
          og_image_type: "",
          article_modified_time: "",
          canonical_link: "",
          twitter_card: "",
          twitter_title: "",
          twitter_description: "",
          twitter_site: "",
        });
        setCheckUpImg(null);
        setTestMasterInclusions([]);
        setSelectedTestMaster("");
        setSelectedInclusionIds([]);
      } else {
        toast.error("Failed to add health checkup.");
      }
    } catch (err) {
      console.error(err);
      setError("An error occurred while adding health checkup.");
      toast.error("An error occurred while adding health checkup.");
    } finally {
      setLoading(false);
    }
  };

  console.log("testMasters:", testMasters);

  return (
    <Box m="20px">
      <ToastContainer />
      <Typography variant="h4">Add Health Checkup</Typography>

      {error && <Alert severity="error">{error}</Alert>}

      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <TextField
          fullWidth
          label="Health Checkup Package Name"
          margin="normal"
          name="health_checkup_name"
          value={formData.health_checkup_name}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          label="Slug"
          margin="normal"
          name="slug"
          value={formData.slug}
          onChange={handleChange}
        />
        {loadingSpecialities ? (
          <CircularProgress size={24} />
        ) : (
          <FormControl fullWidth margin="normal">
            <InputLabel id="speciality-label">Speciality</InputLabel>
            <Select
              labelId="speciality-label"
              name="speciality_id"
              value={formData.speciality_id}
              onChange={handleChange}
              required
            >
              {specialities.map((speciality) => (
                <MenuItem key={speciality.id} value={speciality.id}>
                  {speciality.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        {loadingDoctors ? (
          <CircularProgress size={24} />
        ) : (
          <FormControl fullWidth margin="normal">
            <InputLabel id="doctor-label">Doctors</InputLabel>
            <Select
              labelId="doctor-label"
              name="doctor_id"
              value={formData.doctor_id}
              onChange={handleChange}
              required
            >
              {doctors.map((doc) => (
                <MenuItem key={doc.id} value={doc.id}>
                  {doc.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        {/* Master test selection */}
        {/* <FormControl fullWidth margin="normal">
          <InputLabel id="master-test-label">Select Master Test</InputLabel>
          <Select
            labelId="master-test-label"
            value={selectedTestMaster}
            onChange={(e) => {
              setSelectedTestMaster(e.target.value);
              const selected = testMasters.find((m) => m.id === e.target.value);
              setInclusionForSelectedMaster(selected?.test_inclusions || []);
              setSelectedInclusionIds([]);
            }}
          >
            {testMasters.map((master) => (
              <MenuItem key={master.id} value={master.id}>
                {master.test_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl> */}

        {/* <FormControl fullWidth margin="normal">
          <InputLabel id="multi-master-test-label">Select Master Tests</InputLabel>
          <Select
            multiple
            labelId="multi-master-test-label"
            value={selectedTestMasters}
            onChange={(e) => {
              const selected = e.target.value;
              setSelectedTestMasters(selected);

              const updatedInclusions = selected.map((masterId) => {
                const match = testMasters.find((m) => m.id === masterId);
                return {
                  test_master_id: masterId,
                  test_inclusions: match?.test_inclusions || [],
                  selected_ids: [],
                };
              });

              setTestMasterInclusions(updatedInclusions);
            }}
            renderValue={(selected) =>
              selected
                .map((id) => testMasters.find((m) => m.id === id)?.test_name)
                .join(", ")
            }
          >
            {testMasters.map((master) => (
              <MenuItem key={master.id} value={master.id}>
                {master.test_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {testMasterInclusions.map((group, index) => (
          <Box key={group.test_master_id} mt={2}>
            <Typography variant="subtitle2">
              {testMasters.find((m) => m.id === group.test_master_id)?.test_name}
            </Typography>
            <Box display="flex" flexDirection="column">
              {group.test_inclusions.map((inc) => (
                <FormControlLabel
                  key={inc.id}
                  control={
                    <Checkbox
                      checked={group.selected_ids?.includes(inc.id)}
                      onChange={(e) => {
                        const updatedInclusions = [...testMasterInclusions];
                        const current = updatedInclusions[index];
                        if (e.target.checked) {
                          current.selected_ids.push(inc.id);
                        } else {
                          current.selected_ids = current.selected_ids.filter(
                            (id) => id !== inc.id
                          );
                        }
                        updatedInclusions[index] = current;
                        setTestMasterInclusions(updatedInclusions);
                      }}
                    />
                  }
                  label={inc.inclusion_name}
                />
              ))}
            </Box>
          </Box>
        ))} */}

        <FormControl fullWidth margin="normal">
          <InputLabel id="master-lbl">Select Master Tests</InputLabel>
          <Select
            multiple
            labelId="master-lbl"
            value={multiIds}
            onChange={handleSelectMasters}
          >
            {testMasters.map((m) => (
              <MenuItem key={m.id} value={m.id}>
                {m.test_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Stack direction="row" spacing={1} mt={1}>
          <TextField
            label="Add New Master"
            value={newMasterName}
            onChange={(e) => setNewMasterName(e.target.value)}
            fullWidth
          />
          <IconButton onClick={addNewMaster}>
            <AddIcon />
          </IconButton>
        </Stack>

        {groups.map((g, gi) => (
          <Box key={gi} mt={2} p={2} border={1} borderRadius={2}>
            <Typography fontWeight={600}>
              {g.test_master_id !== null
                ? testMasters.find((m) => m.id === g.test_master_id).test_name
                : g.test_master_name}
            </Typography>

            {g.test_inclusions.map((inc) => (
              <FormControlLabel
                key={inc.id}
                control={
                  <Checkbox
                    checked={g.test_inclusion_ids.includes(inc.id)}
                    onChange={(e) => toggleId(gi, inc.id, e.target.checked)}
                  />
                }
                label={inc.inclusion_name}
              />
            ))}

            <Stack direction="row" spacing={1} mt={1}>
              <TextField
                size="small"
                placeholder="New inclusion"
                fullWidth
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    addName(gi, e.target.value);
                    e.target.value = "";
                  }
                }}
              />
              <IconButton
                onClick={(e) => {
                  const txt = e.currentTarget.previousSibling.value;
                  addName(gi, txt);
                  e.currentTarget.previousSibling.value = "";
                }}
              >
                <AddIcon fontSize="small" />
              </IconButton>
            </Stack>

            {g.test_inclusion_names.length > 0 && (
              <Typography variant="caption" color="text.secondary">
                New: {g.test_inclusion_names.join(", ")}
              </Typography>
            )}
          </Box>
        ))}

        <TextField
          fullWidth
          label="Checkup_Title"
          margin="normal"
          name="checkup_title"
          value={formData.checkup_title}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          label="Checkup_Fees"
          margin="normal"
          name="checkup_fees"
          value={formData.checkup_fees}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          label="Email"
          margin="normal"
          name="email"
          value={formData.email}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          label="Phone"
          margin="normal"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          label="Contact Person"
          margin="normal"
          name="contact_person"
          value={formData.contact_person}
          onChange={handleChange}
        />

        <SeoTags formData={formData} setFormData={setFormData} />

        <Box mt={2}>
          <Button variant="contained" component="label">
            Upload CheckUp Image
            <input
              type="file"
              accept="image/*"
              hidden
              onChange={(e) =>
                handleFileChange(e, "checkup_image", setCheckUpImg)
              }
            />
          </Button>
          {checkupImg && (
            <Typography
              variant="body2"
              mt={1}
              style={{ marginTop: "10px", fontStyle: "italic" }}
            >
              Selected File:{checkupImg.name}
            </Typography>
          )}
        </Box>

        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={loading}
          style={{ marginTop: "16px", background: '#0ca854' }}
        >
          {loading ? <CircularProgress size={24} /> : "Add Health Checkup"}
        </Button>
      </form>
    </Box>
  );
};

export default AddHealthCheckup;
